import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=fb0bc5be&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
import style0 from "./Part.vue?vue&type=style&index=0&id=fb0bc5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0bc5be",
  null
  
)

export default component.exports